import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { DeleteOutlined } from "@toddle-edu/ds-icons";

import { useI18n } from "Hooks";

import classes from "./DeletedMessage.scss";

const DeletedMessage = props => {
  const { isSender } = props;
  const { t } = useI18n(["common"]);

  const containerClasses = classNames(classes.container, {
    [classes.senderContainer]: isSender,
    [classes.receiverContainer]: !isSender,
  });

  const messageClasses = classNames(
    "text-textSubtle",
    "text-body-2",
    classes.message
  );

  return (
    <div className={containerClasses}>
      <DeleteOutlined size="xx-small" variant="subtle" />
      <div className={messageClasses}>{t("common:message_was_deleted")}</div>
    </div>
  );
};

DeletedMessage.propTypes = {
  isSender: PropTypes.bool.isRequired,
};

export default DeletedMessage;
